import api from '@/services/api';

const CompanyContractTagCreate = {
  createCompanyContractTag: (companyContractTagId, companyContractTagName) => {
    return api.post('create_company_contract_tag/', {
      companyContractTagId: companyContractTagId,
      companyContractTagName: companyContractTagName
    });
  },
  bulkCreateNotExistCompanyContractTasg: companyContractTags => {
    return api.post('bulk_create_not_exist_company_contract_tags/', {
      companyContractTags: companyContractTags
    });
  },
  createCompanyContractTagV2: (companyContractTagName, remarks, color) => {
    return api.post('create_company_contract_tag_v2/', {
      companyContractTagName: companyContractTagName,
      remarks: remarks,
      color: color
    });
  }
};

export default CompanyContractTagCreate;



// WEBPACK FOOTER //
// ./src/api/tag/create.js